import React from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem, Avatar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined';
// import DiscordIcon from '../assets/discord_clip.svg'; // Import Discord SVG
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import SideDrawer from './SideDrawer';
import ColorModeIconDropdown from '../theme/ColorModeIconDropdown'; // Add this import

const Header: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleLogin = () => {
    navigate('/login');
    handleMenuClose();
  };

  const handleLogout = () => {
    logout();
    navigate('/');
    handleMenuClose();
  };

  const handleProfileNavigation = () => {
    navigate('/profile');
    handleMenuClose();
  };

  return (
    <Box sx={{ flexGrow: 1, width: '100%', borderRadius: 0 }}>
      <AppBar position="static" sx={{ width: '100%', borderRadius: 0 }}>
        <Toolbar>
          <IconButton 
            edge="start" 
            color="inherit" 
            aria-label="menu" 
            sx={{ mr: 2, zIndex: 2000 }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, textAlign: 'left' }}>
            CribCritic
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* Theme switcher */}
            <ColorModeIconDropdown 
              color="inherit" 
              sx={{ 
                border: 'none',
                bgcolor: 'transparent !important',
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,0.1)'
                }
              }} 
            />
            
            {/* User profile button */}
            <IconButton 
              color="inherit" 
              onClick={handleMenuOpen}
              sx={{ 
                border: 'none',
                bgcolor: 'transparent !important',
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,0.1)'
                }
              }}
            >
              {isAuthenticated ? (
                <Avatar src={user?.picture} sx={{ width: 24, height: 24 }} />
              ) : (
                <AccountCircleOutlined />
              )}
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              {!isAuthenticated ? (
                <MenuItem onClick={handleLogin}>Login</MenuItem>
              ) : (
                <>
                  <MenuItem onClick={handleProfileNavigation}>Profile</MenuItem>
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </>
              )}
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <SideDrawer 
        open={drawerOpen} 
        onClose={() => setDrawerOpen(false)}
        onOpen={() => setDrawerOpen(true)}
      />
    </Box>
  );
};

export default Header;
